<template>
    <div class="unit-test">
        <BRow>
            <label for="user-change">使用者工號</label>
            <input id="user-change" type="text" v-model="user.workCode.value">
            <sag-open-window
                serviceName="UnitTest"
                name="openWindow"
                :titles="{
                    windowTitle: '員工清單',
                    buttonName: '員工清單'
                }"
                :GridData="WGridData"
                @submitEvent="res=>{ user.workCode.value = res.Employee_WorkCode }"
            >
            </sag-open-window>
        </BRow>
        <BRow>
            <label for="bookmeal-datelock">BookMeal 鎖定日期開關</label>
            <input id="bookmeal-datelock" type="checkbox" v-model="bookMeal.dateLock">
            <button @click="bookMeal.submit">確認</button>
        </BRow>
        <BRow style="margin-top: 20px;">
            <label for="bookmeal-specDeadLine">BookMeal團膳提早截止日期</label>
            <input id="bookmeal-specDeadLine" type="datetime-local" v-model="BookMealConfig.specDeadLineTime">
            <button @click="BookMealConfig.submit">確認</button>
        </BRow>
        <div style="font-size: small; color: red;">不需要設時分秒</div>
        <BRow style="margin-top: 20px;">
            <button @click="user.changeSubmit">切換使用者</button>
            <button @click="user.adUnlockSubmit" style="margin-left: 1rem;">AD 解鎖</button>
            <button @click="user.erpUnlockSubmit" style="margin-left: 1rem;">ERP 解鎖</button>
        </BRow>
        <BRow style="margin-top: 20px;">
            <label for="sagweb-maintenance">網站維修時間設定</label>
            <input id="sagweb-maintenance" type="datetime-local" v-model="SAGWebConfig.maintenanceTime">
            <button @click="SAGWebConfig.submit">確認</button>
        </BRow>
        
    </div>
</template>
<script>
import { onMounted, ref, reactive, computed, watch } from '@vue/composition-api'
import utils from '@/sag-core/utils.js'
import tools from '@/sag-core/tools.js'
import { BRow, BCol } from 'bootstrap-vue'
import api from './js/api.js'
import store from '@/store'
import router from '@/router'
import Toast from '@/sag-core/other/Toast.js'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

import SagOpenWindow from '@/components/sag-open-window/SagOpenWindow.vue'
import WGridData from './js/WGridData.js'

export default {
    name: 'UnitTest',
    components: {
        BRow,
        BCol,
        SagOpenWindow
    },
    setup(props, ctx) {
        const toast = new Toast()
        const bookMeal = reactive({
            dateLock: false,
            submit: ()=>{
                api.SetDateLock(bookMeal.dateLock).then(response=>{
                    toast.toastSuccess('成功開關')
                }).catch(err=>{
                    toast.toastError(`開關失敗: ${err}`)
                })
            }
        })

        const SAGWebConfig = reactive({
            maintenanceTime: '',
            submit: ()=>{
                let dateStr = tools.dateTimeToStr(new Date(SAGWebConfig.maintenanceTime))
                if(dateStr){
                    api.SetMaintenanceTime(dateStr).then(response=>{
                        toast.toastSuccess('成功設定維修時間')
                    }).catch(err=>{
                        toast.toastError(`設定維修時間失敗: ${err}`)
                    })
                }
            }
        })

        const BookMealConfig = reactive({
            specDeadLineTime: '',
            submit: ()=>{
                let dateStr = tools.dateTimeToStr(new Date(BookMealConfig.specDeadLineTime))
                if(dateStr){
                    api.SetSpecDeadLine(dateStr).then(response=>{
                        toast.toastSuccess('成功設定提早截止時間')
                    }).catch(err=>{
                        toast.toastError(`設定提早截止時間失敗: ${err}`)
                    })
                }
            }
        })

        api.GetDateLock().then(res=>{
            bookMeal.dateLock = res
        })

        api.GetSpecDeadLine().then(res=>{
            BookMealConfig.specDeadLineTime = res
        })
        
        const user = {
            workCode: ref(''),
            changeSubmit: ()=>{
                api.GetUserInfoByAdmin(user.workCode.value).then(response=>{
                    if (response.error_msg != "") {
                          
                    } else {
                        store.dispatch('webConfig/setUser', response.token).then(()=>{
                            const userData = utils.getUserData() 
                            router.replace(getHomeRouteForLoggedInUser(userData.role))
                            .then(() => {
                                
                            })
                        })
                    }
                })
            },
            adUnlockSubmit: ()=>{
                api.ADUnLock(user.workCode.value).then(response=>{
                    toast.toastSuccess('成功解鎖')
                }).catch(err=>{
                    toast.toastError(`解鎖失敗: ${err}`)
                })
            },
            erpUnlockSubmit: () => {
                api.ERPUnLock(
                    user.workCode.value,
                    utils.getUserData().workCode
                ).then(response => {
                    toast.toastSuccess('成功解鎖')
                }).catch(err => {
                    toast.toastError(`解鎖失敗: ${err}`)
                })
            }
        }

        api.GetEmployees().then(res=>{
            // 資料抓取
            WGridData.fillRows(res)
        })

        return {
            bookMeal,
            user,
            WGridData,
            SAGWebConfig,
            BookMealConfig
        }
    }
}
</script>
<style lang="scss">

</style>